import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface IProViewerData {
    newScene: boolean, 
	layers: any, 
	inputs: any, 
	view: any
}

const initialState = {
	newScene: false, 
	layers: null, 
	inputs: null, 
	view: null
} satisfies IProViewerData as IProViewerData;

const viewerHistory = createSlice({
	name: 'viewerHistory',
	initialState: initialState,
	reducers: {
		setData: (state: any, action: PayloadAction<any>) => ({
			...state,
			...action.payload
		})
	}
});

export const { 
	setData,
 } = viewerHistory.actions;

export default viewerHistory.reducer;
